import {SuggestionCategory} from "./types";
import { ReactComponent as FireIcon } from '../assets/fire.svg';
import { ReactComponent as RadarIcon } from '../assets/radar.svg';
import { ReactComponent as LightBulb } from '../assets/lightbulb.svg';
import { ReactComponent as SuggestionArrow } from '../assets/location-arrow.svg';
import { ReactComponent as BookIcon } from '../assets/book-knowledge.svg';
import { ReactComponent as CrownIcon } from '../assets/crown.svg';
import React from 'react';

export const xtmCategories: SuggestionCategory[] = [
    {
        id: 'product-knowledge-base',
        title: 'Product knowledge base',
        icon: (<BookIcon />),
        suggestions: [
            'How can I create a project?',
        ],
    },
    {
        id: 'project-prioritization',
        title: 'Prioritize projects',
        icon: (<FireIcon/>) as any,
        suggestions: ['What are my top priorities today?'],
    },
    {
        id: 'issues-radar',
        title: 'Identify issues',
        icon: (<RadarIcon/>) as any,
        suggestions: [
            'Are there any in-progress tasks missing assignments?',
        ],
    },
];

// XTRF-specific suggestions
export const xtrfCategories: SuggestionCategory[] = [
    {
        id: 'product-knowledge-base',
        title: 'Product knowledge base',
        icon: (<BookIcon />),
        suggestions: [
            'How can I create a project?',
        ],
    },
    {
        id: 'project-management',
        title: 'Prioritize projects',
        icon: (<FireIcon/>) as any,
        suggestions: [
            'What are my highest priority tasks?',
        ],
    },
    {
        id: 'client-queries',
        title: 'Client information',
        icon: <RadarIcon/>,
        suggestions: [
            'Show me overdue projects',
        ],
    },
];

export const xtmMoreSuggestions: SuggestionCategory[] = [
    {
        id: 'base-question',
        title: 'If you are wondering what I can help you with...',
        icon: <LightBulb />,
        suggestions: [
            'What can XTM Agent do?',
        ],
    },
    {
        id: 'additional-queries',
        title: 'Prioritize projects',
        icon: <FireIcon />,
        suggestions: [
            'What are my top priorities today?',
            'Show me high word-count projects due soon',
            'List projects with progress under 50% and near due dates',
        ],
    },
    {
        id: 'issues-radar',
        title: 'Identify issues',
        icon: (<RadarIcon />),
        suggestions: [
            'Are there any in-progress tasks missing assignments?',
            'Show projects in \'Review\' for over a week'
        ],
    }
];

export const xtrfMoreSuggestions: SuggestionCategory[] = [
    {
        id: 'base-question',
        title: 'If you are wondering what I can help you with...',
        icon: <LightBulb />,
        suggestions: [
            'What can XTM Agent do?',
        ],
    },
    {
        id: 'additional-queries',
        title: 'Prioritize projects',
        icon: <FireIcon />,
        suggestions: [
            'What are my highest priority tasks?',
            'List my active projects',
            'Find projects with upcoming deadlines',
        ],
    },
    {
        id: 'client-info',
        title: 'Client information',
        icon: (<RadarIcon />),
        suggestions: [
            'Show me overdue projects for client',
            'List projects with a ROI below 35%'
        ],
    },
    {
        id: 'quick-actions',
        title: 'Quick actions',
        icon: (<SuggestionArrow />),
        suggestions: [
            'List projects for a specific client',
            'Invoice project'
        ],
    },
];